import {css} from "@pandacss/css";
import {createPandaComponent} from "../helpers/pandaComponent.ts";

const horizontalDividerClass = css({
    height: 0,
    borderTop: '1px solid',
    borderColor: 'neutral.280'
})

const HorizontalDivider = createPandaComponent('HorizontalDivider', 'div', [horizontalDividerClass]);

export default HorizontalDivider;